import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';

const NotFound = lazy(() => import('../views/default/NotFound'));

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/page-not-found',
  component: NotFound,
});
